import { FullScreenLayout } from 'ui/fullScreen/FullScreenLayout';

import { PreviewPane } from './preview/PreviewPane';
import { DataPane } from '../common/PreviewWithDataDataPane';
import { SettingsDrawer } from '../common/SettingsDrawer';
import { EditorContentContainer, LayoutContentContainerFullWidth } from '../common';
import { ViewFooter } from '../common/ViewFooter';
import { ViewHeader } from '../common/ViewHeader';
import { useTemplateQueryContext } from '../context/TemplateQueryContext';
import { useInAppPreviewContext } from './context/InAppPreviewContext';
import { PreviewContentContainer } from '../common/PreviewContentContainer';
import { PreviewWithDataError } from '../common/PreviewWithDataError';
import { PreviewWithErrorContainer } from '../common/EditorContentContainer.styled';

export const TEMPLATE_EDITOR_IN_APP_PREVIEW_W_DATA = 'template-editor-in-app-preview-w-data';

export const PreviewWithDataCore = () => {
  const { onRefreshPreview, previewError } = useInAppPreviewContext();

  return (
    <EditorContentContainer data-test={TEMPLATE_EDITOR_IN_APP_PREVIEW_W_DATA}>
      <DataPane onRefreshPreview={onRefreshPreview} />
      <PreviewWithErrorContainer>
        {previewError && <PreviewWithDataError previewError={previewError} />}
        <PreviewPane />
      </PreviewWithErrorContainer>
    </EditorContentContainer>
  );
};

export const PreviewWithData = () => {
  const { onRefreshPreview } = useInAppPreviewContext();
  const { refetch } = useTemplateQueryContext();

  return (
    <FullScreenLayout
      actionBarIsAnchored
      DrawerContent={
        <SettingsDrawer
          onSaveSuccess={() => {
            onRefreshPreview();
            refetch();
          }}
        />
      }
      HeaderContent={<ViewHeader />}
      FooterContent={<ViewFooter />}
    >
      <PreviewContentContainer data-test="template-editor-inapp-preview">
        <LayoutContentContainerFullWidth>
          <PreviewWithDataCore />
        </LayoutContentContainerFullWidth>
      </PreviewContentContainer>
    </FullScreenLayout>
  );
};

export default PreviewWithData;
